import TextCursor from "../TextCursor";
import styles from "./Contacts.module.scss";
import CONTACTS from "../../../../constants/contacts.json";
import { ReactComponent as UnderlineSvg } from "../../../../assets/images/underline.svg";
import { memo } from "react";
import PointerCursor from "../PointerCursor";

function Contacts() {
  const renderCategory = (category: any) => {
    return (
      <div key={category.title} className={styles.category}>
        <span className={styles.category__title}>{category.title}</span>
        <PointerCursor>
          <a
            draggable={false}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.category__item}
            href={category.link}
          >
            {category.value}
          </a>
        </PointerCursor>
      </div>
    );
  };

  return (
    <div className={styles.contacts}>
      <section>
        <div className={styles.header}>
          <TextCursor>
            <span>Contacts</span>
          </TextCursor>
          <UnderlineSvg className={styles.underline} />
        </div>
        <div className={styles.list}>{CONTACTS.map(renderCategory)}</div>
      </section>
    </div>
  );
}

export default memo(Contacts);
